import { useCallback, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Lenis from "lenis";

export function scrollToId(id, immediate = false) {
  const el = document.getElementById(id);
  if (!el) return;
  const lenis = window.__lenis;
  if (lenis) lenis.scrollTo(el, { offset: -72, immediate, duration: 1.2 });
  else el.scrollIntoView({ behavior: immediate ? "auto" : "smooth", block: "start" });
}

export function useSectionNav() {
  const navigate = useNavigate();
  const location = useLocation();
  return useCallback(
    (id) => {
      if (location.pathname === "/") {
        scrollToId(id);
        window.history.replaceState(null, "", id === "home" ? "/" : `/#${id}`);
      } else {
        navigate(`/#${id}`);
      }
    },
    [location.pathname, navigate],
  );
}

export function useLenis() {
  const { hash } = useLocation();
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return undefined;
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    window.__lenis = lenis;
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    if (!hash) return;
    const t = setTimeout(() => scrollToId(hash.slice(1), true), 60);
    return () => clearTimeout(t);
  }, [hash]);
}
